import { formatNumber } from "@wrstudios/utils";
import PropTypes from "prop-types";
import React from "react";
import IllustrationRdcMatchingBuyers from "../../illustrations/IllustrationRdcMatchingBuyers";
import { useLive } from "../LiveProvider";
import Preview from "./LivePreview";

function LivePreviewRdcMatchingBuyers({ title }) {
  const { rdc } = useLive();

  return (
    <Preview
      illustration={<IllustrationRdcMatchingBuyers />}
      title={title}
      subTitle={
        rdc.isLoading
          ? "Loading..."
          : formatNumber(rdc.data?.buyers?.totalBuyers?.byBudget || 0)
      }
    />
  );
}

LivePreviewRdcMatchingBuyers.propTypes = {
  title: PropTypes.string.isRequired
};

export default LivePreviewRdcMatchingBuyers;
